import { Input, InputProps } from "antd"
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons"
import { useState } from "react"
import { isPasswordValid } from "lib/form"
import React from "react"

const Details = ({ password }: { password: string }) => {
  return (
    <isPasswordValid.Container>
      <ul>
        <isPasswordValid.Contenant
          text={`10 caractères`}
          valid={isPasswordValid.isMoreThanTenCharLength(password)}
        />
      </ul>
      <ul>
        <isPasswordValid.Contenant
          text={`Une lettre minuscule`}
          valid={isPasswordValid.containOneMinusChar(password)}
        />
      </ul>
      <ul>
        <isPasswordValid.Contenant
          text={`Une lettre majuscule`}
          valid={isPasswordValid.containOneCapsChar(password)}
        />
      </ul>
      <ul>
        <isPasswordValid.Contenant
          text={`Un chiffre`}
          valid={isPasswordValid.containOneNumeric(password)}
        />
      </ul>
    </isPasswordValid.Container>
  )
}
const NewPassword = (
  props: InputProps & { visible?: boolean }
): JSX.Element => {
  const password = (props.value as string) || ""
  const [visible, setVisilibity] = useState(props.visible ?? true)
  if (visible) {
    return (
      <>
        <Input
          {...props}
          suffix={
            <EyeOutlined
              onClick={() => {
                setVisilibity(false)
              }}
            />
          }
        />
        <Details password={password} />
      </>
    )
  }

  return (
    <>
      <Input.Password
        {...props}
        iconRender={(visible) =>
          visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
        }
      />
      <Details password={password} />
    </>
  )
}

export default NewPassword
